import React from 'react';
import CTABlock from './cta';

const HubSpotMeeting = () => {
  return <CTABlock />;
};

export default HubSpotMeeting;
